import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import fintech from "../../../Assets/fintech.png";
import SectionWrapper from "../UI/SectionWrapper";
import { COLORS } from "../../../Constants/colors";


const Section = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: ${COLORS.background};
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 1rem 2rem;
 background: linear-gradient(135deg, #0f0f0f, #1a1a1a 75%,rgb(186, 87, 15) 130%);




  color: ${COLORS.textPrimary};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

const Image = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: fit;
    display: block;
  }

  @media (max-width: 1024px) {
    border-radius: 16px 16px 0 0;
  }
`;

const Intro = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: ${COLORS.textSecondary};

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const FeatureList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.6rem;

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

const FeatureItem = styled.div`
 background: linear-gradient(135deg, #0f0f0f, #1a1a1a 80%, #ff6a00 130%);
  padding: 1rem;
  border-radius: 12px;
  transition: transform 0.2s ease;
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  &:hover {
    transform: translateY(-4px);
  }
`;

const Icon = styled.div`
  font-size: 1.5rem;
  color: ${COLORS.primary};
`;

const TextContent = styled.div`
  h4 {
    margin: 0;
    font-size: 1rem;
    color: ${COLORS.primary};
  }

  p {
    margin-top: 0.3rem;
    font-size: 1.1rem;
    color: ${COLORS.textPrimary};
  }

  @media (max-width: 480px) {
    h4 {
      font-size: 1rem;
    }

    p {
      font-size: 0.95rem;
    }
  }
`;


const ButtonWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const ExpandButton = styled.button`
  display: inline-block;
  padding: 10px 16px;
  border: 2px solid ${COLORS.primary};
  color: ${COLORS.primary};
  background: transparent;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  cursor:pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: ${COLORS.primary};
    color: ${COLORS.buttonText};
    transform: translateY(-2px);
  }
`;

const SubText = styled.p`
  font-size: 1rem;
  font-style: italic;
  color: ${COLORS.primary};
  margin-bottom: 0;
  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const FinTechComponent = ({ heading, subText, intro, features, image, onViewMore }) => {  
    return (
        <SectionWrapper heading={heading}>
            <Section>
                <Content>
                    {subText && <SubText>{subText}</SubText>} 
                <Intro>{intro}</Intro>
                <FeatureList>
                    {features?.map((feature, index) => (
                    <FeatureItem key={index}>
                        <Icon>{feature.icon}</Icon>
                        <TextContent>
                        <h4>{feature.title}</h4>
                        </TextContent>
                    </FeatureItem>
                    ))}
                </FeatureList>
                {onViewMore && (
                    <ButtonWrapper>
                        <ExpandButton onClick={onViewMore}>
                            Read More →
                        </ExpandButton>
                    </ButtonWrapper>
                )}
                </Content>
                <Image>
                    <img src={image} alt={heading} />
                </Image>
            </Section>
        </SectionWrapper>
    );
};

const FintechConfig = {
  heading: "FinTech & NBFC",
  subText: "Transforming financial services through technology",
  intro:
      "Virtuosoft Technologies deliver innovative FinTech and NBFC solutions that power digital lending, payments, gold purchase, loan management, compliances and financial management. Combining deep FinTech & NBFC domain expertise with AI and advanced analytics, we create secure, scalable, and compliance-ready platforms that help financial institutions grow and serve customers better.",
  image: fintech,
  features: [
      {
        icon: "⚙️",
        title: "Technology Enablement",
      },
      {
        icon: "🧲",
        title: "Customer Acquisition & Onboarding",
      },
      {
        icon: "💳", 
        title: "Payments & Collections",
        },
      {
        icon: "📊",
        title: "Analytics & Risk Management",
      },
  ],
};


function FinTechSection() {
  const navigate = useNavigate();

  return (
    <FinTechComponent
        subText={FintechConfig.subText}
        heading={FintechConfig.heading}
        intro={FintechConfig.intro}
        features={FintechConfig.features}
        image={FintechConfig.image}
        onViewMore={() => navigate("/fintech")}
    />
  );
}

export default FinTechSection;
